import { render } from "./ZNBJedit.vue?vue&type=template&id=55883611&scoped=true"
import script from "./ZNBJedit.vue?vue&type=script&lang=js"
export * from "./ZNBJedit.vue?vue&type=script&lang=js"

import "./ZNBJedit.vue?vue&type=style&index=0&id=55883611&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55883611"]])

export default __exports__